import React from 'react'
import { Link } from 'react-router-dom'

import { compareStrings, formatPhone, intlPhone } from '../lib/utils'

const EmployeeRef = ({ employee }) => (
  <>
    <Link to={`/person/${employee.id}`}>{employee.preferredName || employee.firstName} {employee.lastName}</Link>{' '}
    <small className='text-muted'>({employee.jobTitle})</small>
  </>
)

const PersonView = ({ employee }) => {
  const { firstName, preferredName, lastName, jobTitle, department, manager, cellphone, email, SAID, reports } = employee

  const sortedReports = [...reports].sort((a, b) => compareStrings(a.lastName, b.lastName))

  return (
    <>
      <h2>{preferredName || firstName} {lastName}</h2>

      <dl class='row'>
        <dt class='col-sm-3'>Job title</dt>
        <dd class='col-sm-9'>{jobTitle}</dd>

        <dt class='col-sm-3'>Department</dt>
        <dd class='col-sm-9'>{department}</dd>

        <dt class='col-sm-3'>Line manager</dt>
        <dd class='col-sm-9'>
          {manager
            ? <EmployeeRef employee={manager} />
            : <>(none)</>}
        </dd>

        <dt class='col-sm-3'>Cellphone</dt>
        <dd class='col-sm-9'>
          {cellphone
            ? <a href={`tel:+${intlPhone(cellphone)}`}>{formatPhone(cellphone)}</a>
            : <>(not listed)</>}
        </dd>

        <dt class='col-sm-3'>Email</dt>
        <dd class='col-sm-9'>{email ? <a href={`mailto:${email}`}>{email}</a> : <>(not listed)</>}</dd>

        {SAID
          ? (
            <>
              <dt class='col-sm-3'>ID number</dt>
              <dd class='col-sm-9'>{SAID}</dd>
            </>
            )
          : null}

        {reports.length
          ? (
            <>
              <dt class='col-sm-3'>Direct reports</dt>
              <dd class='col-sm-9'>
                <ul className='list-unstyled'>
                  {sortedReports.map(e => <li key={e.id}><EmployeeRef employee={e} /></li>)}
                </ul>
              </dd>
            </>
            )
          : null}
      </dl>
    </>
  )
}

export default PersonView
